import axios from 'axios'

export async function fetchActors(accessToken: string | undefined) {
  let headers = { 'x-from-workforce': '1' }
  if (accessToken) {
    headers = Object.assign({}, headers, { Authorization: `Bearer ${accessToken}` })
  }
  const response = await axios({
    url: '/api/actor',
    headers,
    method: 'get'
  }).then(({ data }) => {
    return data.data
  })
  return {
    actors: response.actors,
    intercomUserJwt: response.intercom_user_jwt
  }
}

export async function freshenUserLink(accessToken: string | undefined) {
  let headers = { 'x-from-workforce': '1' }
  if (accessToken) {
    headers = Object.assign({}, headers, { Authorization: `Bearer ${accessToken}` })
  }
  const response = await axios({
    url: '/api/user_link',
    headers,
    method: 'post'
  })

  return response
}
